
var constants = require('./constants');
var awsConstants = constants.awsConstants;
var availableLocales = constants.serverConstants.availableLocales;
var filekeyHelpers = require('./filekey-helpers');
var groupBy = require('./group-by');
var publish = require('./publish-handler');
var moment = require('moment');
const { notificationFormModel } = require('./notification-page');

if (!global.test) {
    var auth = require('./auth-handler');
    var authHandler = auth.authHandler;
    var swal = require('bootstrap-sweetalert');
    swal.setDefaults({ animation: false });
}

function dateFromString(dateString) {
    var date = new Date(dateString);
    if (isNaN(date)) {
        date = moment(dateString, "YYYY-MM-DD hh:mm:ss Z").toDate()
    }
    return date
}

var firmwareListModel = {
    init: function () {
        if (!localStorage.getItem('resource2-list')) {
            localStorage.setItem('resource2-list', JSON.stringify([]));
        }
        if (!localStorage.getItem('published')) {
            localStorage.setItem('published', JSON.stringify({}));
        }
        // init state for column sorting
        // only the latest filter is active at any time.
        var sortState = {
            date: { active: true, direction: true },
            version: { active: false, direction: false },
            model: { active: false, direction: false },
            status: { active: false, direction: false },
            username: { active: false, direction: false },
            firmwarename: { active: false, direction: false }
        };
        if (!localStorage.getItem('sort-state')) {
            localStorage.setItem('sort-state', JSON.stringify(sortState));
        }

        if (!localStorage.getItem('filtered-model')) {
            localStorage.setItem('filtered-model', '');
            this.currentFilteredModel = '';
        }
        // keeps track of action processing state for action buttons (delete, publish, push notification)
        this.processingState = {};
        this.initActionProcessingState();
    },
    initActionProcessingState: function () {
        var self = this;
        var publishedFirmware = self.getPublishedFirmware();
        Object.keys(publishedFirmware).forEach(function (model) {
            if (publishedFirmware[model] && publishedFirmware[model].length) {
                publishedFirmware[model].forEach(function (firmware) {
                    if (!self.processingState[firmware.model + firmware.version + firmware.firmware]) {
                        self.processingState[firmware.model + firmware.version + firmware.firmware] = {};
                    }
                });
            }
        });
    },
    updateActionProcessingState: function (model, version, firmware, action, state) {
        this.processingState[model + version + firmware][action] = state;
    },
    getModels: function() {
        return JSON.parse(localStorage.getItem('models'));
    },
    getPublishedFirmware: function () {
        return JSON.parse(localStorage.getItem('published'));
    },
    updateModels: function(models) {
        localStorage.setItem('models', JSON.stringify(models));
    },
    updatePublishedFirmware: function (publishedFirmware) {
        localStorage.setItem('published', JSON.stringify(publishedFirmware));
    },
    updatePublishedFilterActive: function (state) {
        if (state) {
            localStorage.setItem('published-filter-active', 'on');
        } else {
            localStorage.setItem('published-filter-active', 'off');
        }
    },
    updateResource2List: function (list) {
        localStorage.setItem('resource2-list', JSON.stringify(list));
    },
    getResource2List: function () {
        return JSON.parse(localStorage.getItem('resource2-list'));
    },
    getSortState: function () {
        return JSON.parse(localStorage.getItem('sort-state'));
    },
    getCurrentFilteredModel: function () {
        return localStorage.getItem('filtered-model');
    },
    getPublishedFilterActive: function () {
        var status = localStorage.getItem('published-filter-active');
        return status === 'on';
    },
    getCurrentlyPublishedFirmware: function () {
        var publishedFirmware = this.getPublishedFirmware();
        var currentlyPublishedFirmwareKeys = [];
        Object.keys(publishedFirmware).forEach(function (model) {
            if (publishedFirmware[model] && publishedFirmware[model].length) {
                currentlyPublishedFirmwareKeys.push(
                    publishedFirmware[model].sort(function (a, b) {
                        return dateFromString(b.date) - dateFromString(a.date);
                    })[0]);
            }
        });
        return currentlyPublishedFirmwareKeys;
    },
    updateSortState: function (sortProperty) {
        var sortState = this.getSortState();
        Object.keys(sortState).forEach(function (key) {
            if (key === sortProperty) {
                sortState[key].active = true;
                sortState[key].direction = !sortState[key].direction;
            } else {
                sortState[key].active = false;
                sortState[key].direction = false;
            }
        });
        localStorage.setItem('sort-state', JSON.stringify(sortState));
    },
    updateCurrentFilteredModel: function (model) {
        this.currentFilteredModel = model;
        localStorage.setItem('filtered-model', model);
    },
    getActionProcessingState: function () {
        return this.processingState;
    },
    getMetadataForFirmware: function (firmwareKey) {
        var list = this.getList();
        return list.find(function (firmware) {
            if (firmware.firmware) {
                return firmware.firmware === firmwareKey;
            }
        });
    },
    updatePublishedFirmwareOnSuccess: function (firmware) {
        var publishedFirmware = this.getPublishedFirmware();
        var existingFirmwareIdx = publishedFirmware[firmware.model]
            .findIndex(function (o) {
                return o.model === firmware.model && o.version === firmware.version && o.firmware === o.firmware;
            });
        if (existingFirmwareIdx > -1) {
            publishedFirmware[firmware.model][existingFirmwareIdx] = firmware;
        }
        this.updatePublishedFirmware(publishedFirmware);
        firmwareListView.render();
    }
};

var firmwareListController = {
    init: function () {
        var self = this;
        var buckets = [awsConstants.buckets.std, awsConstants.buckets.act];
        firmwareListModel.init();
        firmwareListView.init(...buckets);

        if (!self.s3listenerInited) {
            self.s3listenerInited = true;
            // Custom event when S3 object credentials are ready initialized
            document.addEventListener('s3Ready', function () {
                if (window.location.hash !== '#/dashboard') {
                    return;
                }
                return self.getModels(...buckets).then(function(modelArray) {
                    firmwareListModel.updateModels(modelArray.flatMap(models => models));
                    firmwareListModel.initActionProcessingState();
                    firmwareListView.renderModelSelectOptions();
                    firmwareListView.render();
                })
                .catch(function (error) {
                    swal('S3 Firmware List Update Error', error, 'error');
                });
            });
        }
    },
    deviceInfoFromMetadata(metadata) {
        var requiredKeys = ['version', 'firmware', 'firmware_version', 'model', 'firmware_name'];
        var optionalKeys = ['resource1', 'resource1_version', 'resource1_checksum', 'resource2', 'resource2_version', 'resource2_checksum', 'persist', 'persist_version'];
        availableLocales.forEach(function (locale) {
            optionalKeys.push(`resource2_${locale}`);
        });
        requiredKeys.forEach(requiredKey => {
            if (requiredKey in metadata === false) {
                throw `missing required key ${requiredKey}`
            }
        });
        var deviceInfo = requiredKeys.concat(optionalKeys).reduce((newObj, key) => (metadata[key] ? newObj[key] = metadata[key] : key, newObj), {});
        return deviceInfo;
    },
    getModels(stdBucket, actBucket) {
        var self = this;
        var promises = [];
        return authHandler.refreshTokenIfNeeded()
            .then(function () {
                promises.push(self.getListedModels(actBucket));
                promises.push(self.getListedModels(stdBucket));
                return Promise.all(promises)
            });
    },
    getListedModels: function(bucket) {
        var prefix = 'published/';
        return window.s3.listObjects({
            Bucket: bucket,
            Delimiter: '/',
            Prefix: prefix
        }).promise()
            .then(function (list) {
                return list.CommonPrefixes.flatMap(function(prefixObj) {
                    var model = prefixObj.Prefix.split('/')[1]
                    // drop models with leading whitespace
                    var valid = (model == model.replace(/\s+/g, ''));
                    return valid ? [{model: model, bucket: bucket}] : [];
                });
            });
    },
    getPublishedFirmwareLogs: function (stdBucket, actBucket) {
        var self = this;
        var promises = [];
        return authHandler.refreshTokenIfNeeded()
            .then(function () {
                promises.push(self.getPublishedFirmwareS3Keys(stdBucket).then(function (keys) {
                    return self.getPublishedFirmwareLogFiles(stdBucket, keys);
                }));
                promises.push(self.getPublishedFirmwareS3Keys(actBucket).then(function (keys) {
                    return self.getPublishedFirmwareLogFiles(actBucket, keys);
                }));
                return Promise.all(promises)
            });
    },
    getPublishedFirmwareS3Keys: function (bucket, model) {
        var prefix = `published/${model}`;
        return authHandler.refreshTokenIfNeeded().then(function() {
            return window.s3.listObjects({
                Bucket: bucket,
                Prefix: prefix
            }).promise()
                .then(function (list) {
                    return list.Contents
                        .map(function (item) {
                            return item.Key;
                        });
                });
            });
    },
    getPublishedFirmwareLogFiles: function (bucket, publishedFirmwareS3Keys) {
        return authHandler.refreshTokenIfNeeded().then(function() {
            var promises = [];
            if (publishedFirmwareS3Keys && publishedFirmwareS3Keys.length) {
                publishedFirmwareS3Keys.forEach(function (key) {
                    promises.push(window.s3.getObject({
                        Bucket: bucket,
                        Key: key
                    }).promise().then(function (item){
                        var body = JSON.parse(item.Body);
                        body.bucket = bucket;
                        return body;
                    }));
                });
            }
            return Promise.all(promises)
        });
    },
    getFirmwareListFromServer: function (bucket) {
        return window.s3.listObjects({ Bucket: bucket }).promise();
    },
    getObjects: function (bucket, keys) {
        var self = this;
        var promises = [];
        keys.forEach(function (key) {
            promises.push(self.getObject(bucket, key));
        });
        return promises;
    },
    generateReleaseNotesPromises: function (keys) {
        var self = this;
        var promises = [];
        keys.forEach(function (key) {
            promises.push(self.getObject(key).then(function (data) {
                var dict = {};
                dict[key] = self.parsePublishedJSONFile(data);
                return dict;
            }));
        });
        return promises;
    },
    generateGetMetadataPromises: function (bucket, keys) {
        var self = this;
        var promises = [];
        keys.forEach(function (key) {
            promises.push(self.getMetadata(bucket, key));
        });
        return promises;
    },
    getObject: function (bucket, key) {
        return window.s3.getObject({ Bucket: bucket, Key: key }).promise();
    },
    getMetadata: function (bucket, key) {
        return window.s3.headObject({ Bucket: bucket, Key: key }).promise()
            .then(function (result) {
                return result.Metadata;
            });
    },
    updateReleaseNotesFile: function (bucket, metadata) {
        // what if releaseNotesFileKey doesn't exist?
        var releaseNotesFileKey = filekeyHelpers.generateReleaseNotesFileKey(metadata.firmware_name, metadata.model, metadata.checksum);
        var publishedReleaseNotesFileKey = filekeyHelpers.generatePublishedReleaseNotesFileKey(metadata.model);
        var params = {
            Bucket: bucket,
            CopySource: bucket + '/' + releaseNotesFileKey,
            Key: publishedReleaseNotesFileKey,
            Metadata: this.metadataWithoutReleaseNotes(metadata),
            MetadataDirective: 'REPLACE'
        };
        return window.s3.copyObject(bucket, params).promise();
    },
    updateInfoFileJSON: function (bucket, metadata, date) {
        var infoFileKey = filekeyHelpers.generateInformationFileKey(metadata.model);
        var content = {
            model: metadata.model,
            version: metadata.firmware_version,
            firmware: metadata.firmware,
            firmware_version: metadata.firmware_version,
            date: date,
            firmware_name: metadata.firmware_name
        };

        if (metadata.resource1) {
            content.resource1 = metadata.resource1;
        }
        if (metadata.resource1_version) {
            content.resource1_version = metadata.resource1_version;
        }
        if (metadata.resource1_checksum) {
            content.resource1_checksum = metadata.resource1_checksum;
        }

        if (metadata.resource2) {
            content.resource2 = metadata.resource2;
        }

        if (metadata.resource2_version) {
            content.resource2_version = metadata.resource2_version;
        }
        if (metadata.resource2_checksum) {
            content.resource2_checksum = metadata.resource2_checksum;
        }

        var resource2List = firmwareListModel.getResource2List();
        if (resource2List.length) {
            var resource2ByLocale = groupBy(resource2List, 'locale');
            Object.keys(resource2ByLocale).forEach(function (locale) {
                if (availableLocales.indexOf(locale) !== -1) {
                    var latestLocaleFileKey = resource2ByLocale[locale].sort(function (a, b) {
                        return new Date(b.date) - new Date(a.date);
                    })[0].key;
                    content['resource2_' + locale] = latestLocaleFileKey;
                }
            });
        }

        var updateParams = {
            Bucket: bucket,
            Key: infoFileKey,
            Body: JSON.stringify(content),
            ContentType: 'application/json'
        };
        return window.s3.putObject(updateParams).promise();
    },
    showReleaseNotes: function (model, version, firmwareKey) {
        var firmware = firmwareListModel.getPublishedFirmware()[model].find(function (item) {
            return item.firmware === firmwareKey && item.model === model && item.version === version;
        });
        if (!('releaseNotes' in firmware)) {
            swal('View Error', 'No release notes found', 'error');
            return 'error';
        } else {
            swal('Release Notes', firmware.releaseNotes);
        }
    },
    metadataWithoutReleaseNotes: function (metadata) {
        var firmwareWithoutReleaseNotes = Object.assign({}, metadata);
        delete firmwareWithoutReleaseNotes.releaseNotes;
        return firmwareWithoutReleaseNotes;
    },
    getPublishLog: function (bucket, model, version) {
        return window.s3.getObject({
            Bucket: bucket,
            Key: filekeyHelpers.generatePublishLogKey(model, version)
        }).promise();
    },
    publishFile: function (bucket, model, version, firmwareKey) {
        var self = this;
        firmwareListModel.updateActionProcessingState(model, version, firmwareKey, 'publish', true);
        firmwareListView.render();
        authHandler.refreshTokenIfNeeded().then(function () {
            return self.getPublishLog(bucket, model, version);
        })
            .then(function (res) {
                var publishDetails = JSON.parse(res.Body);
                return publish(bucket, publishDetails, true, true);
            })
            .then(function (firmware) {
                firmwareListModel.updateActionProcessingState(model, version, firmwareKey, 'publish', false);
                firmwareListModel.updatePublishedFirmwareOnSuccess(firmware);
                swal('Publish Success', 'Firmware successfully published', 'success');
            })
            .catch(function (error) {
                firmwareListModel.updateActionProcessingState(model, version, firmwareKey, 'publish', false);
                if (error !== 'authexpired' && error !== 'cancelled') {
                    swal('Publish Error', error, 'error');
                }
            });
    },
    pushNotification: function (bucket, model, version, firmwareKey) {
        var self = this;
        var metadata;
        firmwareListModel.updateActionProcessingState(model, version, firmwareKey, 'pushNotification', true);
        firmwareListView.render();

        return authHandler.refreshTokenIfNeeded()
            .then(function () {
                return self.getExistingInformationFileData(bucket, model);
            })
            .then(function (result) {
                metadata = result.data;
                if (!metadata) {
                    throw new Error('An error occurred retrieving firmware metadata please retry or reload page' + model);
                } else if (!self.validateFileMetadata(metadata)) {
                    throw new Error('Metadata for this firmware is invalid please file an issue.');
                }
                return window.sns.listTopics().promise();
            })
            .then(function (result) {
                return self.publishToModel(result.Topics, bucket, model, metadata);
            })
            .then(function (result) {
                swal('Push Notification Success', 'Push notification successfully sent', 'success');
                firmwareListModel.updateActionProcessingState(model, version, firmwareKey, 'pushNotification');
                firmwareListView.render();
            })
            .catch(function (error) {
                if (error !== 'authexpired') {
                    swal('Push Notification Error', error, 'error');
                }
                firmwareListModel.updateActionProcessingState(model, version, firmwareKey, 'pushNotification');
                firmwareListView.render();
            });
    },
    publishToModel: function (topics, bucket, model, metadata) {
        var self = this;
        var promises = [];
        var silentTopic = model + "-silent";
        var standardTopic = model + "-standard"
        var topicArns = topics.map(function (topic) { return topic.TopicArn; });
        var silentTopicArnIdx = topicArns.findIndex(function (topicArn) {
            return topicArn.split(':')[5] === silentTopic;
        });
        var standardTopicArnIdx = topicArns.findIndex(function (topicArn) {
            return topicArn.split(':')[5] === standardTopic;
        });
        var deviceInfo = self.deviceInfoFromMetadata(metadata);
        if (silentTopicArnIdx === -1) {
            promises.push(window.sns.createTopic({ Name: silentTopic }).promise()
                .then(function (data) {
                    console.log('created topic', silentTopic);
                    return self.publishSilentNotification(data.TopicArn, deviceInfo);
                }));
        } else {
            var topicArn = topicArns[silentTopicArnIdx];
            promises.push(self.publishSilentNotification(topicArn, deviceInfo));
        }
        promises.push(notificationFormModel.init().then(function() {
            notificationFormModel.getNotificationAlertForModel(bucket, model).then(function(alert) {
                if (standardTopicArnIdx === -1) {
                    window.sns.createTopic({ Name: standardTopic }).promise()
                        .then(function (data) {
                            console.log('created topic', standardTopic);
                            return self.publishStandardNotification(data.TopicArn, alert, deviceInfo);
                        });
                } else {
                    var topicArn = topicArns[standardTopicArnIdx];
                    return self.publishStandardNotification(topicArn, alert, deviceInfo);
                }
            })
        }));
        return Promise.all(promises)
    },
    validateFileMetadata: function (metadata) {
        if (metadata.firmware) return true;
    },
    publishStandardNotification: function(topicArn, alert, deviceInfo) {
        var APNSObj = {
            aps: {
                category: "UPDATE",
                alert: alert
            },
            'device-info': deviceInfo
        };
        var params = {
            MessageAttributes: {"AWS.SNS.MOBILE.APNS.PUSH_TYPE":{"DataType":"String","StringValue":"alert"}},
            MessageStructure: 'json',
            TopicArn: topicArn
        };

        return this.publishSNSNotification(APNSObj, params)
    },
    publishSilentNotification: function (topicArn, deviceInfo) {
        var APNSObj = {
            aps: {
                'content-available': 1
            },
            'device-info': deviceInfo
        };

        var params = {
            MessageAttributes: {"AWS.SNS.MOBILE.APNS.PUSH_TYPE":{"DataType":"String","StringValue":"background"}},
            MessageStructure: 'json',
            TopicArn: topicArn
        };

        return this.publishSNSNotification(APNSObj, params)
    },
    publishSNSNotification: function(APNSObj, params) {
        console.log(APNSObj);
        if (process.env.NODE_ENV != 'production') {
            console.log('apns sandbox notification');
            params.Message = JSON.stringify({ default: '', APNS_SANDBOX: JSON.stringify(APNSObj) });
        } else {
            console.log('apns notification');
            params.Message = JSON.stringify({ default: '', APNS: JSON.stringify(APNSObj) });
        }
        return window.sns.publish(params).promise();
    },
    // if file exists
    getExistingInformationFileData: function (bucket, model) {
        // Returns information file exists or not exists
        var informationFileKey = filekeyHelpers.generateInformationFileKey(model);
        return window.s3.getObject({ Bucket: bucket, Key: informationFileKey }).promise()
            .then(function (result) {
                if (result) {
                    return { data: JSON.parse(result.Body) };
                } else {
                    return { data: null, responseData: result };
                }
            })
            .catch(function (error) {
                if (error.code === 'NoSuchKey') {
                    var oldInformationFileKey = filekeyHelpers.generateOldInformationFileKey(model);
                    return window.s3.getObject({ Bucket: bucket, Key: oldInformationFileKey }).promise()
                        .then(function (result) {
                            if (result) {
                                return { data: JSON.parse(result.Body) };
                            } else {
                                return { data: null, responseData: result };
                            }
                        });
                }
            })
            .catch(function (error) {
                if (error.code === 'NoSuchKey') {
                    return { data: null, responseData: error };
                };
            });
    },
    updateListWithSort: function (property) {
        firmwareListModel.updateSortState(property);
        var updatedState = firmwareListModel.getSortState();
        var updatedPropertyDirection = updatedState[property].direction;
        firmwareListView.updateSortIcon(property, updatedPropertyDirection);
        firmwareListView.render();
    },
    updateListWithModelFilter: function (model) {
        firmwareListModel.updateCurrentFilteredModel(model);
        firmwareListView.render();
    },
    sortByDate: function (array, direction) {
        if (direction) {
            return array.sort(function (a, b) {
                if (!a.date) {
                    return 1;
                } else if (!b.date) {
                    return -1;
                } else {
                    return new Date(b.date) - new Date(a.date);
                }
            });
        }
        return array.sort(function (a, b) {
            if (!a.lastpublished) {
                return -1;
            } else if (!b.date) {
                return 1;
            } else {
                return new Date(a.date) - new Date(b.date);
            }
        });
    },
    sortByVersion: function (array, direction) {
        var self = this;
        // http://stackoverflow.com/questions/6832596/how-to-compare-software-version-number-using-js-only-number
        if (direction) {
            return array.sort(function (a, b) {
                var v1 = a.version || a.firmware_version;
                var v2 = b.version || b.firmware_version;
                return self.versionCompare(v1, v2);
            }).reverse();
        } else {
            return array.sort(function (a, b) {
                var v1 = a.version || a.firmware_version;
                var v2 = b.version || b.firmware_version;
                return self.versionCompare(v1, v2);
            });
        }
    },
    versionCompare: function (v1, v2) {
        var v1parts = v1.split('.');
        var v2parts = v2.split('.');

        function isValidPart(x) {
            return /^\d+$/.test(x);
        }

        if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
            return NaN;
        }

        for (var i = 0; i < v1parts.length; ++i) {
            if (v2parts.length === i) {
                return 1;
            }

            if (v1parts[i] === v2parts[i]) {
                continue;
            } else if (v1parts[i] > v2parts[i]) {
                return 1;
            } else {
                return -1;
            }
        }

        if (v1parts.length !== v2parts.length) {
            return -1;
        }

        return 0;
    },
    sortGeneric: function (array, property, direction) {
        if (direction) {
            return array.sort(function (a, b) {
                if (a[property] > b[property]) {
                    return -1;
                }
                if (a[property] < b[property]) {
                    return 1;
                }
                return 0;
            });
        }
        return array.sort(function (a, b) {
            if (a[property] < b[property]) {
                return -1;
            }
            if (a[property] > b[property]) {
                return 1;
            }
            return 0;
        });
    },
    sortByPublished: function (array, direction) {
        var publishedFirmwareKeys = firmwareListModel.getCurrentlyPublishedFirmware();
        if (direction) {
            return array.sort(function (a, b) {
                if (publishedFirmwareKeys.indexOf(a.firmware) > -1) {
                    return -1;
                }
                if (publishedFirmwareKeys.indexOf(a.firmware) === -1) {
                    return 1;
                }
                return 0;
            });
        }
        return array.sort(function (a, b) {
            if (publishedFirmwareKeys.indexOf(a.firmware) === -1) {
                return -1;
            }
            if (publishedFirmwareKeys.indexOf(a.firmware) > -1) {
                return 1;
            }
            return 0;
        });
    }
};

var firmwareListView = {
    init: function (stdBucket, actBucket) {
        this.tableBodyEl = document.querySelector('#firmware-table');
        this.modelSortIconEl = document.querySelector('#model-sort');
        this.dateSortIconEl = document.querySelector('#date-sort');
        this.versionSortIconEl = document.querySelector('#version-sort');
        this.statusSortIconEl = document.querySelector('#status-sort');
        this.usernameSortIconEl = document.querySelector('#username-sort');
        this.firmwarenameSortIconEl = document.querySelector('#name-sort');
        this.publishedFilterCheckboxEl = document.querySelector('#published-checkbox');
        this.noFirmwaresAlertEl = document.querySelector('#no-firmwares-alert');
        this.modelSelectEl = document.querySelector('#model-select');
        this.initPublishedCheckbox();
        this.render();
        this.renderModelSelectOptions();
        this.initModelSelectHandler();
        this.initTableSortHandlers();
        this.initActionButtonsHandler(stdBucket, actBucket);
    },
    initPublishedCheckbox: function () {
        if (firmwareListModel.getPublishedFilterActive()) {
            this.publishedFilterCheckboxEl.setAttribute('checked', '');
        }
    },
    initTableSortHandlers: function () {
        this.modelSortIconEl.addEventListener('click', function () {
            firmwareListController.updateListWithSort('model');
        });

        this.dateSortIconEl.addEventListener('click', function () {
            firmwareListController.updateListWithSort('date');
        });

        this.versionSortIconEl.addEventListener('click', function () {
            firmwareListController.updateListWithSort('version');
        });

        this.publishedFilterCheckboxEl.addEventListener('click', function () {
            var isFilterActive = firmwareListModel.getPublishedFilterActive();
            if (isFilterActive) {
                firmwareListModel.updatePublishedFilterActive(false);
            } else {
                firmwareListModel.updatePublishedFilterActive(true);
            }
            firmwareListView.render();
        });

        this.usernameSortIconEl.addEventListener('click', function () {
            firmwareListController.updateListWithSort('username');
        });

        this.firmwarenameSortIconEl.addEventListener('click', function () {
            firmwareListController.updateListWithSort('firmwarename');
        });
    },
    updateSortIcon: function (property, direction) {
        switch (property) {
            case 'date':
                if (direction) {
                    this.dateSortIconEl.className = 'fa fa-sort-desc';
                } else { this.dateSortIconEl.className = 'fa fa-sort-asc'; }
                this.modelSortIconEl.className = 'fa fa-sort';
                this.versionSortIconEl.className = 'fa fa-sort';
                this.usernameSortIconEl.className = 'fa fa-sort';
                this.firmwarenameSortIconEl.className = 'fa fa-sort';
                break;
            case 'model':
                if (direction) { this.modelSortIconEl.className = 'fa fa-sort-desc'; } else {
                    this.modelSortIconEl.className = 'fa fa-sort-asc';
                }
                this.dateSortIconEl.className = 'fa fa-sort';
                this.versionSortIconEl.className = 'fa fa-sort';
                this.usernameSortIconEl.className = 'fa fa-sort';
                this.firmwarenameSortIconEl.className = 'fa fa-sort';
                break;
            case 'version':
                if (direction) { this.versionSortIconEl.className = 'fa fa-sort-desc'; } else {
                    this.versionSortIconEl.className = 'fa fa-sort-asc';
                }
                this.dateSortIconEl.className = 'fa fa-sort';
                this.modelSortIconEl.className = 'fa fa-sort';
                this.usernameSortIconEl.className = 'fa fa-sort';
                this.firmwarenameSortIconEl.className = 'fa fa-sort';
                break;
            case 'status':
                if (direction) { this.statusSortIconEl.className = 'fa fa-sort-desc'; } else {
                    this.statusSortIconEl.className = 'fa fa-sort-asc';
                }
                this.dateSortIconEl.className = 'fa fa-sort';
                this.modelSortIconEl.className = 'fa fa-sort';
                this.versionSortIconEl.className = 'fa fa-sort';
                this.usernameSortIconEl.className = 'fa fa-sort';
                this.firmwarenameSortIconEl.className = 'fa fa-sort';
                break;
            case 'username':
                if (direction) { this.usernameSortIconEl.className = 'fa fa-sort-desc'; } else {
                    this.usernameSortIconEl.className = 'fa fa-sort-asc';
                }
                this.dateSortIconEl.className = 'fa fa-sort';
                this.modelSortIconEl.className = 'fa fa-sort';
                this.versionSortIconEl.className = 'fa fa-sort';
                this.firmwarenameSortIconEl.className = 'fa fa-sort';
                break;
            case 'firmwarename':
                if (direction) { this.firmwarenameSortIconEl.className = 'fa fa-sort-desc'; } else {
                    this.firmwarenameSortIconEl.className = 'fa fa-sort-asc';
                }
                this.dateSortIconEl.className = 'fa fa-sort';
                this.modelSortIconEl.className = 'fa fa-sort';
                this.versionSortIconEl.className = 'fa fa-sort';
                this.usernameSortIconEl.className = 'fa fa-sort';
                break;
            default:
                console.log('unexpected sort property');
        }
    },
    initActionButtonsHandler: function (stdBucket, actBucket) {
        this.tableBodyEl.addEventListener('click', function (e) {
            var buttonEl;
            // Case where button text span is clicked
            if (e.target.parentNode.hasAttribute('data-firmwareKey')) {
                buttonEl = e.target.parentNode;
            } else if (e.target.hasAttribute('data-firmwareKey')) {
                buttonEl = e.target;
            }
            if (!buttonEl) return;
            var bucket = buttonEl.getAttribute('data-bucket');
            var model = buttonEl.getAttribute('data-model');
            var version = buttonEl.getAttribute('data-version');
            var firmwareKey = buttonEl.getAttribute('data-firmwareKey');
            if (buttonEl.classList.contains('publish')) {
                firmwareListController.publishFile(bucket, model, version, firmwareKey);
            } else if (buttonEl.classList.contains('pushNotification')) {
                firmwareListController.pushNotification(bucket, model, version, firmwareKey);
            } else if (buttonEl.classList.contains('showReleaseNotes')) {
                firmwareListController.showReleaseNotes(model, version, firmwareKey);
            }
        });
    },
    initModelSelectHandler: function () {
        this.modelSelectEl.addEventListener('change', function (e) {
            var index = e.target.selectedIndex;
            var modelSelected = e.target.options[index].text;
            var bucket = e.target.value;
            firmwareListController.updateListWithModelFilter(modelSelected);
            if (modelSelected == "") {
                return;
            }
            console.log(`load ${modelSelected} from ${bucket}`);
            firmwareListController.getPublishedFirmwareS3Keys(bucket, modelSelected).then(function(keys) {
                firmwareListController.getPublishedFirmwareLogFiles(bucket, keys).then(function(logs) {
                    console.log(logs);
                    var logsByModel = groupBy(logs, 'model');
                    var publishedFirmware = firmwareListModel.getPublishedFirmware();
                    firmwareListModel.updatePublishedFirmware(Object.assign(publishedFirmware, logsByModel));
                    firmwareListModel.initActionProcessingState();
                    firmwareListView.render();
                });
            });
        });
    },
    showNoCurrentFirmwaresAlert: function () {
        this.noFirmwaresAlertEl.innerHTML = '<div class="alert alert-info"><strong>No current firmwares uploaded</strong></div>';
    },
    // occurs when sort filters are activated or an updated list is loaded from server. Initial list state is cached in local storage if user is already logged in
    generateButtonHtml: function (bucket, model, version, firmware, action, actionState, disabled) {
        var buttonHTML = [];

        buttonHTML.push('<button type="button"  class="btn btn-sm btn-default ' + action + '"' + ' data-firmwareKey="' + firmware + '"' + ' data-version="' + version + '"' + ' data-model="' + model + '"' + ' data-bucket="' + bucket + '"' + ' style="width:12em;display:block;margin:auto;"');

        if (disabled) {
            buttonHTML.push('disabled')
        }
        buttonHTML.push('>')

        if (actionState) {
            buttonHTML.push('<i class="fa fa-circle-o-notch fa-spin fa-fw" style="margin-right:5px"></i>');
            switch (action) {
                case 'publish': buttonHTML.push('<span>Publishing</span>'); break;
                case 'pushNotification': buttonHTML.push('<span>Pushing</span>'); break;
                case 'showReleaseNotes': buttonHTML.push('<span>Viewing</span>'); break;
                default: console.log('unexpected action');
            }
            buttonHTML.push('</button>');
            return buttonHTML.join('\n');
        }

        buttonHTML.push('<i class="fa fa-circle-o-notch fa-spin fa-fw" style="display:none"></i>');
        switch (action) {
            case 'publish': buttonHTML.push('<span>Publish</span>'); break;
            case 'pushNotification': buttonHTML.push('<span>Push Notification</span>'); break;
            case 'showReleaseNotes': buttonHTML.push('<span>View</span>'); break;
            default: console.log('unexpected action');
        }
        buttonHTML.push('</button>');
        return buttonHTML.join('\n');
    },
    generateTableRow: function (firmware) {
        var actionButton1HTML;
        var actionButton2HTML;

        var firmwareVersion = firmware.version || firmware.firmware_version;
        var resource2Version = "---";
        availableLocales.some(function (locale) {
            var resource2Path = firmware['resource2_' + locale]
            if (resource2Path != null) {
                resource2Version = resource2Path.split('_').pop();
                return true;
            }
            return false;
        });

        // Sorting a column or an updated list from the server will trigger a rerender of table. Make sure to keep current processing state for actions (i.e. button spinner, text for publish in progress)
        var currentActionProcessingState = firmwareListModel.getActionProcessingState();
        var isCurrentPublishedFirmware = firmwareListModel.getCurrentlyPublishedFirmware().find(function (item) {
            return item.version === firmware.version && item.model === firmware.model;
        });

        var publishLogContainsNoResource2Files = Object.keys(firmware).filter(function (key) {
            return key.indexOf("resource2") > -1
        }).length == 0

        const processingStateKey = firmware.model + firmware.version + firmware.firmware;

        if (publishLogContainsNoResource2Files) {
            actionButton1HTML = this.generateButtonHtml(firmware.bucket, firmware.model, firmware.version, firmware.firmware, 'publish', false, true);
        } else {
            if (currentActionProcessingState[processingStateKey].publish) {
                actionButton1HTML = this.generateButtonHtml(firmware.bucket, firmware.model, firmware.version, firmware.firmware, 'publish', true, false);
            } else {
                actionButton1HTML = this.generateButtonHtml(firmware.bucket, firmware.model, firmware.version, firmware.firmware, 'publish', false, false);
            }
        }

        if (isCurrentPublishedFirmware) {
            if (currentActionProcessingState[processingStateKey].pushNotification) {
                actionButton2HTML = this.generateButtonHtml(firmware.bucket, firmware.model, firmware.version, firmware.firmware, 'pushNotification', true, false);
            } else {
                actionButton2HTML = this.generateButtonHtml(firmware.bucket, firmware.model, firmware.version, firmware.firmware, 'pushNotification', false, false);
            }
        }

        var username;
        if (firmware.username && firmware.username.toLowerCase() !== 'null') {
            username = firmware.username;
        } else {
            username = '';
        }
        if (username) {
            username = username.charAt(0).toUpperCase() + username.slice(1);
        }
        var statusText;
        var statusRow;
        if (isCurrentPublishedFirmware) {
            statusText = 'Published';
            statusRow = '<td style="vertical-align:middle;width:10em;"><label class="label label-primary">' + statusText + '</label></td>';
        } else {
            statusText = 'Not Published';
            statusRow = '<td style="vertical-align:middle;width:10em;">' + statusText + '</td>';
        }

        const hasReleaseNotes = 'releaseNotes' in firmware;

        var actionHTML = [
            '<tr>',
            '<td style="vertical-align:middle;width:14em;">' + firmware.model + '</td>',
            '<td style="vertical-align:middle;width:12em;">' + firmware.firmware_name + '</td>',
            '<td style="vertical-align:middle;width:12em;">' + firmwareVersion + '</td>',
            '<td style="vertical-align:middle;width:12em;">' + resource2Version + '</td>',
            statusRow
        ];

        var datePublished = dateFromString(firmware.date);
        actionHTML.push('<td style="vertical-align:middle;width:12em;">' + datePublished.toLocaleString() + '</td>');

        var continuation = [
            '<td style="vertical-align:middle;width:6em;">' + username + '</td>',
            '<td style="vertical-align:middle;width:15em;" class="col-md-4 text-center">'
        ];
        actionHTML = actionHTML.concat(continuation);

        if (!isCurrentPublishedFirmware) {
            actionHTML.push(actionButton1HTML);
            actionHTML.push('<span style="display:block;margin:0.8em"></span>');
        }
        if (actionButton2HTML) {
            actionHTML.push(actionButton2HTML);
        }

        var releaseNotesHTML = '<td style="vertical-align:middle;width:10em;">' + (hasReleaseNotes ? this.generateButtonHtml(firmware.bucket, firmware.model, firmware.version, firmware.firmware, 'showReleaseNotes', false) : '') + '</td>';
        actionHTML.push(releaseNotesHTML);
        return actionHTML.join('\n');
    },
    renderModelSelectOptions: function () {
        var self = this;
        var models = firmwareListModel.getModels();
        var currentFilter = firmwareListModel.getCurrentFilteredModel();
        //var models = Object.keys(publishedFirmware);
        this.modelSelectEl.options.length = 0;
        self.modelSelectEl.options[0] = new Option('', '', false, false);
        if (models == null) {
            return
        }
        models.forEach(function (modelObj, index) {
            if (currentFilter && modelObj.model === currentFilter) {
                self.modelSelectEl.options[index + 1] = new Option(modelObj.model, modelObj.bucket, false, true);
            } else {
                self.modelSelectEl.options[index + 1] = new Option(modelObj.model, modelObj.bucket, false, false);
            }
        });
    },
    render: function () {
        var self = this;
        var publishedFirmware = firmwareListModel.getPublishedFirmware();
        var unsortedList = [];
        var sortedList = [];
        var tableStringArray = [];
        var currentSortState = firmwareListModel.getSortState();
        var sortKey = Object.keys(currentSortState).find(function (key) {
            return currentSortState[key].active === true;
        });
        var currentFilteredModel = firmwareListModel.getCurrentFilteredModel();
        var publishedFilterActive = firmwareListModel.getPublishedFilterActive();
        var currentlyPublished = firmwareListModel.getCurrentlyPublishedFirmware();
        if (publishedFilterActive) {
            if (!currentFilteredModel || !currentFilteredModel.length) {
                unsortedList = currentlyPublished;
            } else {
                unsortedList = currentlyPublished.filter(function (o) {
                    return o.model === currentFilteredModel;
                });
            }
        } else {
            if (!currentFilteredModel || !currentFilteredModel.length) {
                Object.keys(publishedFirmware).forEach(function (key) {
                    if (publishedFirmware[key] && publishedFirmware[key].length) {
                        publishedFirmware[key].forEach(function (item) {
                            unsortedList.push(item);
                        });
                    }
                });
            } else {
                if (publishedFirmware[currentFilteredModel] && publishedFirmware[currentFilteredModel].length) {
                    publishedFirmware[currentFilteredModel].forEach(function (item) {
                        unsortedList.push(item);
                    });
                }
            }
        }
        switch (sortKey) {
            case 'version':
                sortedList = firmwareListController.sortByVersion(unsortedList, currentSortState[sortKey].direction);
                if (currentSortState[sortKey].direction) {
                    this.versionSortIconEl.className = 'fa fa-sort-desc';
                } else {
                    this.versionSortIconEl.className = 'fa fa-sort-asc';
                }
                break;
            case 'status':
                sortedList = firmwareListController.sortByPublished(unsortedList, currentSortState[sortKey].direction);
                if (currentSortState[sortKey].direction) {
                    this.statusSortIconEl.className = 'fa fa-sort-desc';
                } else {
                    this.statusSortIconEl.className = 'fa fa-sort-asc';
                }
                break;
            case 'date':
                sortedList = firmwareListController.sortByDate(unsortedList, currentSortState[sortKey].direction);
                if (currentSortState[sortKey].direction) {
                    this.dateSortIconEl.className = 'fa fa-sort-desc';
                } else {
                    this.dateSortIconEl.className = 'fa fa-sort-asc';
                }
                break;
            case 'model':
                sortedList = firmwareListController.sortGeneric(unsortedList, 'model', currentSortState[sortKey].direction);
                if (currentSortState[sortKey].direction) {
                    this.modelSortIconEl.className = 'fa fa-sort-desc';
                } else {
                    this.modelSortIconEl.className = 'fa fa-sort-asc';
                }
                break;
            case 'username':
                sortedList = firmwareListController.sortGeneric(unsortedList, 'username', currentSortState[sortKey].direction);
                if (currentSortState[sortKey].direction) {
                    this.modelSortIconEl.className = 'fa fa-sort-desc';
                } else {
                    this.modelSortIconEl.className = 'fa fa-sort-asc';
                }
                break;
            case 'firmwarename':
                sortedList = firmwareListController.sortGeneric(unsortedList, 'firmware_name', currentSortState[sortKey].direction);
                if (currentSortState[sortKey].direction) {
                    this.firmwarenameSortIconEl.className = 'fa fa-sort-desc';
                } else {
                    this.firmwarenameSortIconEl.className = 'fa fa-sort-asc';
                }
                break;
            default: console.log('unexpected sort key');
        }

        sortedList.forEach(function (item) {
            tableStringArray.push(self.generateTableRow(item));
        });

        this.tableBodyEl.innerHTML = tableStringArray.join('\n');
    }
};

module.exports = { firmwareListController: firmwareListController, firmwareListModel: firmwareListModel };
